<app-user-navigation class="pcoded-navbar"
  [ngClass]="{'navbar-collapsed' : navCollapsed, 'theme-horizontal': this.nextConfig['layout'] === 'horizontal', 'mob-open' : navCollapsedMob}"
  (onNavMobCollapse)="navMobClick()"></app-user-navigation>
<app-user-nav-bar class="navbar pcoded-header navbar-expand-lg navbar-light header-blue"
  (onNavCollapse)="this.navCollapsed = !this.navCollapsed;" (onNavHeaderMobCollapse)="navMobClick()"></app-user-nav-bar>
<div class="pcoded-main-container">
  <div class="pcoded-content"
    [ngClass]="{'container': this.nextConfig.layout === 'horizontal' && this.nextConfig.subLayout === 'horizontal-2'}">
    <app-breadcrumb></app-breadcrumb>
    <router-outlet></router-outlet>
  </div>
</div>
<app-user-configuration></app-user-configuration>